import React from 'react'
import { Row, Col } from '@themesberg/react-bootstrap'
import { Formik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Buffer } from 'buffer'
import { toast } from '../../../../components/Toast'
import StaffForm from './StaffForm'
import { createStaffAdminStart } from '../../../../store/redux-slices/staffSlice'
import { HeaderSection, ResponsiveTitle, ButtonContainer } from '../../TransactionsBanking/style'
import NotificationIconContainer from '../../../../components/NotificationIcon/NotificationIconContainer'
import { createStaffSchema } from '../schema'
import { ROLES } from '../constants'
import PageBackButton from '../../../../components/PageBackButton'

const CreateStaff = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { adminDetails: { adminRoleId, adminUserId, AdminRole: { name } } } = useSelector(state => state.admins)


  const handleCreateSubmit = (formValues) => {
    // if (formValues.role === 'Manager') {
    //   delete formValues.adminId
    // } else {
    // formValues.adminId = Number(formValues?.adminId)
    // }

    if ([undefined, null].includes(formValues.permission) || Object.keys(formValues.permission).length < 1) {
      toast('Please select at least one permission', 'error')
    } else {
      dispatch(createStaffAdminStart({
        data: {
          adminId: parseInt(formValues?.adminId) || adminUserId,
          adminUsername: formValues.adminUsername,
          password: Buffer.from(formValues.password).toString('base64'),
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          email: formValues.email,
          phone: `${formValues.phoneCode} ${formValues.phone}`,
          countryCode: formValues.countryCode.toUpperCase(),
          isPhoneVerified: formValues.isPhoneVerified,
          userType: formValues?.role || name?.toLowerCase(),
          group: formValues.group,
          adminRoleId: ROLES.find(role => role.title === formValues.role)?.roleId,
          profile: {
            role: formValues.role,
            roleId: ROLES.find(role => role.title === formValues.role)?.roleId
          },
          permission: formValues.permission
        }, 
        navigate
      }))
    }
  }

  return (
    <div>
      <HeaderSection className="section-header-wrap">
        <Row className="justify-content-between align-items-center g-3">
          <Col md={6}>
          <div className='backbtn'>
          <PageBackButton />
            <ResponsiveTitle className="title-text">
              Create Staff
            </ResponsiveTitle>
          </div>
         
          </Col>

          <Col>
            <ButtonContainer className="d-flex justify-content-md-end">
              <div className="ms-auto ms-md-2">
                <NotificationIconContainer />
              </div>
            </ButtonContainer>
          </Col>
        </Row>
      </HeaderSection>

      <Formik
        initialValues={{
          email: '',
          password: '',
          adminUsername: '',
          firstName: '',
          lastName: '',
          role: null,
          permission: {},
          group: '',
          adminId: '',
          countryCode: '',
          phoneCode: '',
          phone: '',
          isPhoneVerified: false
        }}
        enableReinitialize
        validationSchema={createStaffSchema}
        onSubmit={(formValues) => handleCreateSubmit(formValues)}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          setFieldValue,
          setFieldTouched,
          setFieldError,
          dirty,
          isValid,
          errors,
          touched,
          validateField
        }) => (
          <StaffForm
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            setFieldError={setFieldError}
            errors={errors}
            touched={touched}
            isValid={isValid}
            validateField={validateField}
            dirty={dirty}
            isEdit={false}
          />
        )}
      </Formik>
    </div>
  )
}

export default CreateStaff
